"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const room_type_price_setting_1 = require("../../enums/room-type-price-setting");
const dnaR_input_type_enum_1 = require("../../../common/components/dnaR-input/enums/dnaR-input-type.enum");
const forms_1 = require("@angular/forms");
const organisation_model_1 = require("../../organisation.model");
const dnaR_dropdown_multiSelect_model_1 = require("../../../common/components/dnaR-dropdown-multiSelect/dnaR-dropdown-multiSelect.model");
require("../../dtos/saveAccommodationTypePriceHistoryDto");
require("../../dtos/accommodationPriceHistoryDto");
const AccommodationTypeDto_1 = require("../../dtos/AccommodationTypeDto");
const dnaR_action_modal_component_1 = require("../../../common/components/dnaR-action-modal/dnaR-action-modal.component");
const dialog_1 = require("@angular/material/dialog");
const i0 = require("@angular/core");
const i1 = require("@angular/forms");
const i2 = require("@angular/material/dialog");
const i3 = require("@angular/common");
const i4 = require("@angular/material/button");
const i5 = require("@angular/material/tooltip");
const i6 = require("@angular/material/icon");
const i7 = require("../../../common/components/dnaR-input/dnaR-input.component");
const i8 = require("../../../common/components/dnaR-datePicker/dnaR-datePicker.component");
const i9 = require("../../../common/components/dnaR-dropdown-multiSelect/dnaR-dropdown-multiSelect.component");
function AccommodationTypePriceHistoryModalComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "Per bed / room");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c0 = function (a0) { return [a0]; };
function AccommodationTypePriceHistoryModalComponent_div_29_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelement(1, "dnaR-dropdown-multiSelect", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const formGroup_r2 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("placeholder", "Select setting")("settings", ctx_r5.dropdownSettings)("data", ctx_r5.priceSettingList)("initialSelectedItems", i0.ɵɵpureFunction1(4, _c0, formGroup_r2.get("priceSetting").value.id));
} }
const _c1 = function () { return ["", 0]; };
function AccommodationTypePriceHistoryModalComponent_div_29_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelementStart(1, "div", 14);
    i0.ɵɵelement(2, "dnaR-input", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, AccommodationTypePriceHistoryModalComponent_div_29_div_1_div_3_Template, 2, 6, "div", 16);
    i0.ɵɵelementStart(4, "div", 17);
    i0.ɵɵelementStart(5, "dnaR-date-picker", 33);
    i0.ɵɵlistener("onComponentChange", function AccommodationTypePriceHistoryModalComponent_div_29_div_1_Template_dnaR_date_picker_onComponentChange_5_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r9 = i0.ɵɵnextContext(); const formGroup_r2 = ctx_r9.$implicit; const i_r3 = ctx_r9.index; const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.validateDuplicateEffectiveDate($event, formGroup_r2, i_r3); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 18);
    i0.ɵɵelementStart(7, "a", 34);
    i0.ɵɵlistener("click", function AccommodationTypePriceHistoryModalComponent_div_29_div_1_Template_a_click_7_listener() { i0.ɵɵrestoreView(_r8); const formGroup_r2 = i0.ɵɵnextContext().$implicit; const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.removeClick(formGroup_r2); });
    i0.ɵɵelement(8, "span", 35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const formGroup_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formControl", formGroup_r2.get("price"))("disallowedValues", i0.ɵɵpureFunction0(11, _c1))("value", formGroup_r2.get("price").value)("inputType", ctx_r4.dnaRInputType.currency)("validate", ctx_r4.submitted);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r4.isIluFacility);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", formGroup_r2.get("effectiveDate").value)("validate", ctx_r4.submitted)("duplicate", formGroup_r2.get("isDuplicateDate").value);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("disabled", ctx_r4.formAccommodationPriceHistories.controls.length === 1 ? true : null);
} }
function AccommodationTypePriceHistoryModalComponent_div_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, AccommodationTypePriceHistoryModalComponent_div_29_div_1_Template, 9, 12, "div", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const formGroup_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    i0.ɵɵproperty("formGroup", formGroup_r2);
    i0.ɵɵattribute("data-index", i_r3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", formGroup_r2.get("isDeleted").value != true);
} }
const _c2 = function (a0, a1) { return { ".ilu-modal-dialog": a0, "rac-modal-dialog": a1 }; };
const _c3 = function (a0) { return { "disabled": a0 }; };
class AccommodationTypePriceHistoryModalComponent {
    constructor(formBuilder, dialog) {
        this.formBuilder = formBuilder;
        this.dialog = dialog;
        this.submitted = false;
        this.duplicateDate = false;
        this.roomTypePriceSetting = room_type_price_setting_1.RoomTypePriceSetting;
        this.priceSettingList = [];
        this.selectedNewPriceSetting = [this.roomTypePriceSetting.room];
        this.dropdownSettings = {
            singleSelection: true,
            itemsShowLimit: 1,
            addAllOption: false,
            enableCheckAll: false,
            showClearSelectedItems: false
        };
        this.dnaRInputType = dnaR_input_type_enum_1.DnaRInputType;
        this.isIluFacility = false;
        this.priceHistoryForm = this.formBuilder.group({
            formAccommodationPriceHistories: this.formBuilder.array([])
        });
        this.pupulatePriceSettingList();
    }
    get formAccommodationPriceHistories() {
        return this.priceHistoryForm.controls["formAccommodationPriceHistories"];
    }
    loadData(accommodationTypePriceHistories) {
        // Load Previous updates in the same session
        accommodationTypePriceHistories.forEach(((accommodationPriceHistory, index) => {
            this.addNewFormGroup(index, accommodationPriceHistory);
        }));
    }
    ngOnInit() {
        this.isIluFacility = this.currentAccommodationType.isIluFacility;
        if (this.currentAccommodationType.accommodationTypePriceHistories.length > 0) {
            this.loadData(this.currentAccommodationType.accommodationTypePriceHistories);
        }
        else {
            this.addNewAccommodationPriceHistory();
        }
    }
    addNewAccommodationPriceHistory() {
        const newAccommoPriceHistory = new organisation_model_1.AccommodationPriceHistory();
        newAccommoPriceHistory.id = 0;
        newAccommoPriceHistory.price = 0.00;
        newAccommoPriceHistory.effectiveDate = null;
        newAccommoPriceHistory.priceSetting = this.roomTypePriceSetting.room;
        newAccommoPriceHistory.isDeleted = false;
        this.addNewFormGroup(0, newAccommoPriceHistory);
    }
    addNewFormGroup(atIndex, accommodationPriceHistory) {
        const formGroup = this.formBuilder.group({
            id: [accommodationPriceHistory.id],
            price: [(accommodationPriceHistory.price != undefined) ? parseFloat(accommodationPriceHistory.price.toString()).toFixed(2) : null, forms_1.Validators.required],
            priceSetting: [[this.priceSettingList.find(x => x.id == accommodationPriceHistory.priceSetting.toString())]],
            effectiveDate: [accommodationPriceHistory.effectiveDate, forms_1.Validators.required],
            isDeleted: [accommodationPriceHistory.isDeleted],
            isDuplicateDate: [false]
        });
        this.formAccommodationPriceHistories.insert(atIndex, formGroup);
    }
    pupulatePriceSettingList() {
        this.priceSettingList.push(new dnaR_dropdown_multiSelect_model_1.ListItem({ id: this.roomTypePriceSetting.room, text: 'per room' }));
        this.priceSettingList.push(new dnaR_dropdown_multiSelect_model_1.ListItem({ id: this.roomTypePriceSetting.bed, text: 'per bed' }));
    }
    ngOnChanges() {
        this.currentAccommodationTypeId = this.accommodationTypeId;
        this.currentAccommodationType = this.accommodationType;
    }
    addNewClick() {
        this.addNewAccommodationPriceHistory();
    }
    removeClick(formGroup) {
        if (this.formAccommodationPriceHistories.controls.length > 1) {
            var dialogData = {
                title: "Delete price",
                text: "Are you sure you want to delete this price?",
                action: "Delete",
                actionButtonClass: "btn-primary",
                actionFunction: () => {
                    formGroup.markAsTouched();
                    formGroup.get("isDeleted").setValue(true);
                    if (Number(formGroup.get("id").value) == 0) {
                        this.formAccommodationPriceHistories.controls.splice(this.formAccommodationPriceHistories.controls.indexOf(formGroup), 1);
                    }
                }
            };
            this.dialog.open(dnaR_action_modal_component_1.DnaRActionModalComponent, {
                panelClass: 'custom-dialog-container',
                width: '456px',
                height: 'hug',
                data: dialogData
            });
        }
    }
    submit() {
        this.submitted = true;
        (setTimeout(_ => {
            // to assure form recalculate it's status
            this.priceHistoryForm.updateValueAndValidity();
            if (this.priceHistoryForm.status === 'VALID') {
                this.saveForm();
            }
        }));
    }
    cancel() {
        this.hideDialogEvent();
    }
    saveForm() {
        var updateAccommodationTypePriceHistoryDto = {
            AccommodationTypeId: this.currentAccommodationTypeId,
            AccommodationTypePriceHistories: []
        };
        this.formAccommodationPriceHistories.controls.forEach((formControl) => {
            var accommodationTypePriceHistoryDto = {
                accommodationTypeId: this.currentAccommodationTypeId,
                id: Number(formControl.get('id').value),
                price: Number(this.removeNoneDigitsButDot(formControl.get('price').value.toString())),
                priceSetting: (this.currentAccommodationType.isIluFacility)
                    ? this.roomTypePriceSetting.unit
                    : formControl.get('priceSetting').value[0].id,
                effectiveDate: formControl.get('effectiveDate').value,
                isDeleted: formControl.get('isDeleted').value
            };
            updateAccommodationTypePriceHistoryDto.AccommodationTypePriceHistories.push(accommodationTypePriceHistoryDto);
        });
        this.saveEventCallBack(updateAccommodationTypePriceHistoryDto);
        this.hideDialogEvent();
    }
    removeNoneDigitsButDot(str) {
        return str.replace(/[^\d.-]/g, '');
    }
    disableSaveButton() {
        var disabled = !this.priceHistoryForm.touched || (this.submitted && this.priceHistoryForm.status !== 'VALID');
        return disabled;
    }
    validateDuplicateEffectiveDate(event, updatedRow, indexUpdated) {
        var updatedEffectiveDate = updatedRow.get('effectiveDate');
        var updatedEffectiveDateValue = updatedEffectiveDate.value;
        updatedRow.get('isDuplicateDate').setValue(false); //  clear updated error
        if (updatedEffectiveDateValue != undefined) {
            updatedEffectiveDateValue = new Date(updatedEffectiveDateValue);
            this.formAccommodationPriceHistories.controls.forEach((otherRow, index) => {
                var otherRowEffectiveDate = otherRow.get('effectiveDate');
                var otherEffectiveDateValue = new Date(otherRowEffectiveDate.value);
                var otherRowIsDuplicateDate = otherRow.get('isDuplicateDate').value;
                if (otherRowIsDuplicateDate == true && indexUpdated != index) {
                    otherRowEffectiveDate.setErrors(null);
                    otherRow.get('isDuplicateDate').setValue(false); // clear other erros 
                }
                if (indexUpdated != index && otherEffectiveDateValue.getTime() == updatedEffectiveDateValue.getTime()) {
                    updatedEffectiveDate.setErrors({ 'duplicate': true });
                    updatedRow.get('isDuplicateDate').setValue(true);
                    return;
                }
            });
        }
    }
}
exports.AccommodationTypePriceHistoryModalComponent = AccommodationTypePriceHistoryModalComponent;
AccommodationTypePriceHistoryModalComponent.ɵfac = function AccommodationTypePriceHistoryModalComponent_Factory(t) { return new (t || AccommodationTypePriceHistoryModalComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i2.MatDialog)); };
AccommodationTypePriceHistoryModalComponent.ɵcmp = i0.ɵɵdefineComponent({ type: AccommodationTypePriceHistoryModalComponent, selectors: [["accommodation-type-price-history-modal"]], inputs: { accommodationTypeId: "accommodationTypeId", accommodationType: "accommodationType", hideDialogEvent: "hideDialogEvent", saveEventCallBack: "saveEventCallBack" }, features: [i0.ɵɵNgOnChangesFeature], decls: 43, vars: 12, consts: [[1, "modal-dialog", "angular-dialog", 3, "ngClass"], [1, "modal-content"], ["mat-dialog-title", "", 1, "modal-header", "modal-header-action"], [1, "col-xs-11", "noSidePadding"], [1, "modal-title"], [1, "col-xs-1", "noSidePadding"], ["mat-icon-button", "", "matTooltip", "Cancel", "matTooltipClass", "mat-tooltip", "aria-label", "close dialog", "mat-dialog-close", "", 1, "close-modal", "pull-right", 3, "click"], [1, "icon", "icon-close-fill", "close-modal-icon"], [3, "formGroup"], [1, "modal-body"], [1, "col-xs-12", "noSidePadding"], [1, "subtitle"], [1, "col-xs-12", "noSidePadding", "priceList"], [1, "col-xs-12", "noSidePadding", "listHeader"], [1, "column", "priceColumn"], [1, "required"], ["class", "column priceSettingColumn", 4, "ngIf"], [1, "column", "effectiveDateColumn"], [1, "column", "deleteColumn"], ["formArrayName", "formAccommodationPriceHistories", 1, "col-xs-12", "noSidePadding", "listItems"], [3, "formGroup", 4, "ngFor", "ngForOf"], [1, "col-xs-12", "noSidePadding", "list-footer"], [1, "col-xs-8", "noSidePadding", "info"], [1, "col-xs-4", "btn", "addNewItemButton", "pull-right", 3, "click"], [1, "icon", "icon-primary-t2", "icon-add-circle-fill"], [1, "modal-footer", "col-xs-12"], [1, "action-buttons"], ["type", "button", 1, "btn", "btn-warning", "modal-warning-button", "pull-left", 3, "click"], ["type", "submit", 1, "btn", "btn-primary", "modal-action-button", "pull-left", 3, "ngClass", "disabled", "click"], [1, "column", "priceSettingColumn"], ["class", "col-xs-12 noSidePadding item", 4, "ngIf"], [1, "col-xs-12", "noSidePadding", "item"], ["name", "price", "formControlName", "price", "prefix", "$", "toRight", "true", "required", "true", "requiredError", "Price required", 3, "formControl", "disallowedValues", "value", "inputType", "validate"], ["name", "effectiveDate", "formControlName", "effectiveDate", "required", "true", "requiredError", "Effective date required", "duplicateError", "Date conflicts with existing record", 3, "value", "validate", "duplicate", "onComponentChange"], ["title", "Delete", 1, "deleteLink", 3, "click"], [1, "icon", "icon-delete-fill"], ["name", "priceSetting", "formControlName", "priceSetting", "data-automation", "newPriceSetting", 3, "placeholder", "settings", "data", "initialSelectedItems"]], template: function AccommodationTypePriceHistoryModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "h3", 4);
        i0.ɵɵtext(5, "Price");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "button", 6);
        i0.ɵɵlistener("click", function AccommodationTypePriceHistoryModalComponent_Template_button_click_7_listener() { return ctx.cancel(); });
        i0.ɵɵelement(8, "mat-icon", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "form", 8);
        i0.ɵɵelementStart(10, "div", 9);
        i0.ɵɵelementStart(11, "div", 10);
        i0.ɵɵelementStart(12, "h3", 11);
        i0.ɵɵtext(13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 12);
        i0.ɵɵelementStart(15, "div", 13);
        i0.ɵɵelementStart(16, "div", 14);
        i0.ɵɵelementStart(17, "span", 15);
        i0.ɵɵtext(18, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "span");
        i0.ɵɵtext(20, "Price");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(21, AccommodationTypePriceHistoryModalComponent_div_21_Template, 3, 0, "div", 16);
        i0.ɵɵelementStart(22, "div", 17);
        i0.ɵɵelementStart(23, "span", 15);
        i0.ɵɵtext(24, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(25, "span");
        i0.ɵɵtext(26, "Effective date");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(27, "div", 18);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "div", 19);
        i0.ɵɵtemplate(29, AccommodationTypePriceHistoryModalComponent_div_29_Template, 2, 3, "div", 20);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(30, "div", 21);
        i0.ɵɵelementStart(31, "span", 22);
        i0.ɵɵtext(32, "Showing last 12 months");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(33, "button", 23);
        i0.ɵɵlistener("click", function AccommodationTypePriceHistoryModalComponent_Template_button_click_33_listener() { return ctx.addNewClick(); });
        i0.ɵɵelementStart(34, "span");
        i0.ɵɵtext(35, "New price");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(36, "span", 24);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(37, "div", 25);
        i0.ɵɵelementStart(38, "div", 26);
        i0.ɵɵelementStart(39, "button", 27);
        i0.ɵɵlistener("click", function AccommodationTypePriceHistoryModalComponent_Template_button_click_39_listener() { return ctx.cancel(); });
        i0.ɵɵtext(40, "Cancel");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(41, "button", 28);
        i0.ɵɵlistener("click", function AccommodationTypePriceHistoryModalComponent_Template_button_click_41_listener() { return ctx.submit(); });
        i0.ɵɵtext(42, "Done");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c2, ctx.currentAccommodationType.isIluFacility, !ctx.currentAccommodationType.isIluFacility));
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("formGroup", ctx.priceHistoryForm);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.currentAccommodationType.name);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngIf", !ctx.isIluFacility);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngForOf", ctx.formAccommodationPriceHistories.controls);
        i0.ɵɵadvance(12);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c3, ctx.disableSaveButton()))("disabled", ctx.disableSaveButton());
    } }, directives: [i3.NgClass, i2.MatDialogTitle, i4.MatButton, i5.MatTooltip, i2.MatDialogClose, i6.MatIcon, i1.ɵangular_packages_forms_forms_y, i1.NgControlStatusGroup, i1.FormGroupDirective, i3.NgIf, i1.FormArrayName, i3.NgForOf, i7.DnaRInput, i1.NgControlStatus, i1.FormControlName, i1.RequiredValidator, i1.FormControlDirective, i8.DnaRDatePicker, i9.DnaRDropdownMultiSelect], styles: [".modal-dialog[_ngcontent-%COMP%] {\n  width: 492px;\n}\n.ilu-modal-dialog[_ngcontent-%COMP%] {\n  width: 492px;\n}\n.rac-modal-dialog[_ngcontent-%COMP%] {\n  width: 668px!important;\n}\n.close-modal[_ngcontent-%COMP%] {\n  position: relative;\n  width: 40px !important;\n  height: 40px !important;\n  top: -5px;\n  background-color: #ffffff;\n  border: none;\n  padding: 0;\n  border-radius: 50%;\n}\n.close-modal[_ngcontent-%COMP%]:hover, .close-modal[_ngcontent-%COMP%]:focus {\n  background-color: #EBF5F5;\n}\n.close-modal-icon[_ngcontent-%COMP%] {\n  width: 30px;\n  height: 30px;\n  background-color: #949494 !important;\n  font-family: 'Source Sans Pro' !important;\n}\n.modal-header[_ngcontent-%COMP%] {\n  background-color: #ffffff;\n}\n.modal-header.modal-header-action[_ngcontent-%COMP%] {\n  padding-left: 25px;\n  padding-bottom: 4px;\n  margin-bottom: 0px;\n  display: flex;\n}\n.modal-content[_ngcontent-%COMP%], .modal-body[_ngcontent-%COMP%] {\n  display: inline-block;\n  float: left;\n}\n.modal-footer[_ngcontent-%COMP%] {\n  border: none;\n  border-top: 1px solid #D2D2D2;\n  padding: 15px;\n}\n.modal-footer[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]    + .btn[_ngcontent-%COMP%] {\n  margin-left: 10px;\n}\n.action-buttons[_ngcontent-%COMP%] {\n  width: 150px;\n  float: right;\n}\n.modal-footer[_ngcontent-%COMP%]   button[_ngcontent-%COMP%] {\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px;\n}\n.footer-left-button[_ngcontent-%COMP%] {\n  float: left;\n}\n.footer-right-button[_ngcontent-%COMP%] {\n  float: right;\n}\n.modal-footer[_ngcontent-%COMP%]   button.disabled[_ngcontent-%COMP%] {\n  border-color: #D2D2D2;\n  background-color: #F5F5F5;\n  color: #757575;\n}\n.modal-title[_ngcontent-%COMP%], .subtitle[_ngcontent-%COMP%] {\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 30px;\n  letter-spacing: 0.03px;\n  color: #414141;\n}\n.subtitle[_ngcontent-%COMP%] {\n  margin: 15px 0 30px 0;\n}\n.required[_ngcontent-%COMP%] {\n  color: #C53535;\n  padding-right: 5px;\n}\n.priceList[_ngcontent-%COMP%] {\n  display: block;\n  background-color: #ffffff;\n  border-top: 2px solid #D2D2D2;\n  border-bottom: 2px solid #D2D2D2;\n}\n.column[_ngcontent-%COMP%] {\n  display: inline-block;\n  float: left;\n  margin: 0 16px;\n}\n.column[_ngcontent-%COMP%]   span[_ngcontent-%COMP%] {\n  line-height: 20px;\n}\n.priceColumn[_ngcontent-%COMP%] {\n  width: 164px;\n}\n.priceSettingColumn[_ngcontent-%COMP%] {\n  width: 144px;\n}\n.effectiveDateColumn[_ngcontent-%COMP%] {\n  width: 144px;\n}\n.deleteColumn[_ngcontent-%COMP%] {\n  width: 24px;\n}\n.listHeader[_ngcontent-%COMP%] {\n  border-bottom: 1px solid #D2D2D2;\n  font-weight: bold;\n  height: 56px;\n  display: inline-block;\n  font-style: normal;\n  font-weight: 600;\n  letter-spacing: 0;\n  color: #595959;\n  line-height: 56px;\n  vertical-align: middle;\n}\n.listItems[_ngcontent-%COMP%] {\n  background-color: #ffffff;\n  display: block;\n}\n.listItems[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%] {\n  display: inline-block;\n  border-top: 1px solid #D2D2D2;\n  height: auto;\n  min-height: 50px;\n  padding: 8px 0 0 0;\n}\n.listItems[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%]   .deleteLink[_ngcontent-%COMP%] {\n  height: 24px;\n  width: 24px;\n  padding: 0;\n  margin: 7px 0 0 0;\n  display: inline-block;\n}\n.listItems[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%]   .deleteLink[_ngcontent-%COMP%]   span[_ngcontent-%COMP%] {\n  display: inline-block;\n}\n.list-footer[_ngcontent-%COMP%] {\n  display: block;\n  height: 32px;\n  margin-top: 20px;\n}\n.list-footer[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%] {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: 0;\n  color: #414141;\n}\n.addNewItemButton[_ngcontent-%COMP%] {\n  line-height: 20px;\n  color: #008381;\n  background-color: #F5F5F5;\n  font-weight: 600;\n  float: right;\n  border: none;\n  outline: none;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.addNewItemButton[_ngcontent-%COMP%]   span[_ngcontent-%COMP%] {\n  display: inline-block;\n  float: right;\n  padding-left: 8px;\n  color: #008381;\n}\n.addNewItemButton[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:hover {\n  color: #025450;\n  text-decoration: underline;\n}\n.noLeftPadding[_ngcontent-%COMP%] {\n  padding-left: 0!important;\n}\n.disabled[_ngcontent-%COMP%] {\n  cursor: not-allowed;\n}"] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(AccommodationTypePriceHistoryModalComponent, [{
        type: core_1.Component,
        args: [{
                templateUrl: './accommodation-type-price-history-modal.component.html',
                styleUrls: ['./accommodation-type-price-history-modal.component.less'],
                selector: 'accommodation-type-price-history-modal',
            }]
    }], function () { return [{ type: i1.FormBuilder }, { type: i2.MatDialog }]; }, { accommodationTypeId: [{
            type: core_1.Input
        }], accommodationType: [{
            type: core_1.Input
        }], hideDialogEvent: [{
            type: core_1.Input
        }], saveEventCallBack: [{
            type: core_1.Input
        }] }); })();
